const { Component } = Shopware;

Component.override('sw-cms-detail', {
    computed: {
        cmsPageTypes() {
            const cmsPageTypes = this.$super('cmsPageTypes');
            if (cmsPageTypes && !cmsPageTypes.cms_faq) {
                cmsPageTypes.cms_faq = this.$tc('acris-faq.cms.pageTypeFaqLayout');
            }
            return cmsPageTypes;
        },

        // fallback for < 6.4.12.0
        cmsTypeMappingEntities() {
            const cmsTypeMappingEntities = this.$super('cmsTypeMappingEntities');
            if (cmsTypeMappingEntities && !cmsTypeMappingEntities.cms_faq) {
                cmsTypeMappingEntities.cms_faq = {
                    entity: 'acris_faq',
                    mode: 'single',
                }
            }

            return cmsTypeMappingEntities;
        },
        // added in 6.4.12.0
        cmsPageTypeSettings() {
            const faqMappingEntity = {
                cms_faq: {
                    entity: 'acris_faq',
                    mode: 'single'
                }
            }

            if (this.page.type === 'cms_faq') {
                return faqMappingEntity[this.page.type];
            }
            return this.$super('cmsPageTypeSettings');
        },
    }
});
